import {
    CardCollection,
    DateIO,
    Instance,
    Knot,
    Objekt,
    pluck,
    Promize,
    Query,
} from '@siposdani87/sui-js';
import { app } from '../app';
import { AssetService } from '@services/assetService';
import { HuntingPackageService } from '@services/huntingPackageService';
import { LanguageService } from '@services/languageService';
import { OrganizationService } from '@services/organizationService';
import { UtilService } from '@services/utilService';
import { initCardCollection } from '@utils/collectionSetup';
import { DashboardController } from './dashboardController';

export class HuntingPackagesIndexController extends DashboardController {
    static readonly inject = [
        'instances',
        'huntingPackageService',
        'organizationService',
        'utilService',
        'assetService',
        'languageService',
    ] as const;

    huntingPackageCardCollection!: CardCollection;

    constructor(
        instances: Instance,
        private huntingPackageService: HuntingPackageService,
        private organizationService: OrganizationService,
        private utilService: UtilService,
        private assetService: AssetService,
        private languageService: LanguageService,
    ) {
        super(instances);
    }

    protected override _initLayout(): void {
        this._initToolbarButtons();
        this._initFilterForm();

        this._drawContent();
    }

    protected override _drawContent(): Promize | boolean {
        this._initHuntingPackageCardCollection();
        return true;
    }

    private _initToolbarButtons(): void {
        this.helper.fabButton('.btn-hunting-packages-new', this.dom, () => {
            this.huntingPackageService
                .newDialog('organizations', 'organization_id')
                .then(() => {
                    this._drawContent();
                });
        });

        this.helper.iconButton('.btn-site-home', this.dom, () => {
            this.state.goBack('site.home');
        });
    }

    private _initHuntingPackageCardCollection(): void {
        this.huntingPackageCardCollection = initCardCollection(
            this.huntingPackageCardCollection,
            this.dom,
            '.hunting-package-collection',
            this.huntingPackageService,
            {
                entityKey: 'hunting_packages',
                fetchData: (params) =>
                    this.huntingPackageService.getAll(params),
                extraParams: (params) => {
                    params.set('query', this.query);
                    params.set('organization_ids', this.organizationIds);
                    params.set(
                        'fields',
                        'id,title,end_at,plan.full_name,people.name,' +
                            this.organizationService.getAssociationTableFields(),
                    );
                },
            },
            this._huntingPackageCardKnot.bind(this),
            {
                getPersonNames: this.getPersonNames.bind(this),
            },
            { sort: { column: 'start_at', order: 'desc' } },
        )!;
    }

    private _huntingPackageCardKnot(
        cardKnot: Knot,
        huntingPackage: Objekt,
    ): void {
        this._initHuntingPackageActivity(cardKnot, huntingPackage);
        this._initHuntingPackageShowButton(cardKnot, huntingPackage);
        this._initCardButtons(cardKnot, huntingPackage);
        this.utilService.initOrganizationLink(cardKnot, huntingPackage);
    }

    private _initHuntingPackageActivity(
        cardKnot: Knot,
        huntingPackage: Objekt,
    ): void {
        const cardItem = new Query('.card', cardKnot).getKnot();
        const endAt = DateIO.parse(huntingPackage.get<string>('end_at'));
        const cssClass = DateIO.isBefore(new Date(), endAt)
            ? 'active'
            : 'inactive';
        cardItem.addClass(cssClass);
    }

    private _initHuntingPackageShowButton(
        cardKnot: Knot,
        huntingPackage: Objekt,
    ): void {
        this.helper.link(
            'a.card',
            cardKnot,
            (href) => {
                this.state.go(href);
            },
            this.state.resolveUrl('hunting_packages.show', {
                huntingPackageId: huntingPackage.get<string>('id'),
            }),
        );
    }

    private _initCardButtons(cardKnot: Knot, huntingPackage: Objekt): void {
        // let actionsKnot = new Query('.actions', cardKnot).getKnot();
    }

    getPersonNames(people: Array<any>): string {
        return pluck(people, 'name').join(', ');
    }
}

export const huntingPackagesIndexController = app.controller(
    'huntingPackagesIndexController',
    HuntingPackagesIndexController,
);
